// Session token lives in an HttpOnly cookie set by the backend on login.
// Cookies are sent automatically by the browser when credentials:'include'
// is set, so we no longer need to attach an Authorization header — and
// since the token never enters JS-readable storage, an XSS payload can't
// exfiltrate it. The `user` parameter is kept for backward compatibility
// with existing callers and is unused.
//
// In dev, frontend (port 3000) hits backend (8080) via CRA's "proxy"
// setting in package.json, so requests are effectively same-origin and
// SameSite=Strict cookies flow normally.
export async function fetchWithAuth(url, options = {}, user, onAuthError) {
  try {
    const response = await fetch(url, {
      ...options,
      credentials: 'include',
    });
    if (response.status === 401) {
      if (onAuthError) onAuthError();
      return new Promise(() => {}); // Stop further processing
    }
    return response;
  } catch (err) {
    // Aborts are expected (component unmount, dep change) — don't log them.
    if (err?.name !== 'AbortError') {
      console.error("Fetch error:", err);
    }
    throw err;
  }
}
